export default __webpack_public_path__ + "static/media/Q11_0_resized.737f78bc.jpg";